import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../Data/ReduxViewModels/Admin';
import {
  Button,
  ButtonGroup,
  Dropdown,
  Field,
  PasswordInput,
  RadioGroup,
  TextAreaInput,
  TextInput,
  TextOutput,
} from '../../../Core';
import { FieldSet } from '../../../Layout';
import { DbAuthenticationMethod } from './type';

const DatabaseConnectionSection = ({ connection, connectionName, setName, hideProviderSelection = true }) => {
  const dispatch = useDispatch();
  const startTest = () => {
    dispatch(actions.testDatabaseConnection({ path: connection.Name }));
  };

  const path = useSelector((state) => state.admin.databaseConnectionTest.path);
  const testing = useSelector((state) => state.admin.databaseConnectionTest.testing);
  const success = useSelector((state) => state.admin.databaseConnectionTest.success);
  const error = useSelector((state) => state.admin.databaseConnectionTest.error);
  if (!connection) return null;
  let disableTesting = true;
  if (connection.IsAssisted) {
    disableTesting = connection.DataSource === '' || connection.InitialCatalog === '';
  } else if (!connection.IsAssisted) {
    disableTesting = connection.CustomProvider === '';
  }
  const isTesting = path === connection.Name;
  const isAssisted = connection.IsAssisted;
  const providerOptions = (connection.ProviderLists || []).map((font) => ({
    value: font.Value,
    label: font.Label,
  }));
  let statusMessage = null;
  let successMessage = null;
  let errorMessage = null;
  let disabled = false;
  if (isTesting) {
    if (success) {
      successMessage = 'Test was successful';
    }
    if (testing) {
      statusMessage = 'Testing database connection...';
      disabled = true;
    }
    errorMessage = error;
  }
  return (
    <FieldSet key={connectionName}>
      <Field
        label="Name"
        input={setName ? <TextInput /> : <TextOutput />}
        name={`syncModel.${connectionName}.Name`}
        disabled={disabled}
      />
      <Field
        input={<RadioGroup />}
        label="Configuration"
        name={`syncModel.${connectionName}.IsAssisted`}
        disabled={disabled}
        options={[
          { label: 'Assisted', value: true },
          { label: 'Manual', value: false },
        ]}
      />
      {isAssisted ? (
        <Field
          input={<RadioGroup />}
          label="Authentication Method"
          name={`syncModel.${connectionName}.AuthenticationMethod`}
          defaultValue={DbAuthenticationMethod.WindowAuth}
          disabled={disabled}
          options={[
            { label: 'Windows Authentication', value: DbAuthenticationMethod.WindowAuth },
            { label: 'Entra ID Integrated Authentication', value: DbAuthenticationMethod.EntraIDAuth },
            { label: 'SQL Server Authentication', value: DbAuthenticationMethod.SQLServerAuth },
          ]}
        />
      ) : (
        <></>
      )}
      {!isAssisted ? (
        <>
          {hideProviderSelection === false && (
            <Field
              input={<Dropdown />}
              label="Provider"
              isClearable={false}
              defaultValue={'System.Data.SqlClient'}
              name={`syncModel.${connectionName}.CustomProvider`}
              disabled={disabled}
              options={providerOptions}
              simpleValue
            />
          )}
          <Field
            input={<TextAreaInput />}
            label="Connection String"
            rows={8}
            disabled={disabled}
            name={`syncModel.${connectionName}.ManualConnectionString`}
            messages={[
              { message: statusMessage, severity: 'info' },
              { message: successMessage, severity: 'success' },
              { message: errorMessage, severity: 'error' },
            ]}
          />
        </>
      ) : (
        <>
          <Field
            label="Server"
            input={<TextInput />}
            disabled={disabled}
            name={`syncModel.${connectionName}.DataSource`}
          />
          <Field
            label="Database Name"
            input={<TextInput />}
            disabled={disabled}
            name={`syncModel.${connectionName}.InitialCatalog`}
            messages={
              connection.AuthenticationMethod !== DbAuthenticationMethod.SQLServerAuth
                ? [
                    { message: statusMessage, severity: 'info' },
                    { message: successMessage, severity: 'success' },
                    { message: errorMessage, severity: 'error' },
                  ]
                : null
            }
          />
        </>
      )}

      {!(connection.AuthenticationMethod === DbAuthenticationMethod.WindowAuth) &&
      isAssisted &&
      !(connection.AuthenticationMethod === DbAuthenticationMethod.EntraIDAuth) ? (
        <>
          <Field
            label="User ID"
            input={<TextInput />}
            disabled={disabled}
            name={`syncModel.${connectionName}.UserID`}
          />
          <Field
            label="Password"
            input={<PasswordInput />}
            disabled={disabled}
            onCopy="return false"
            name={`syncModel.${connectionName}.Password`}
            messages={[
              { message: statusMessage, severity: 'info' },
              { message: successMessage, severity: 'success' },
              { message: errorMessage, severity: 'error' },
            ]}
          />
        </>
      ) : null}
      <ButtonGroup>
        <Button loading={isTesting && testing} onClick={() => startTest()} primary disabled={disableTesting}>
          Test Database Connection
        </Button>
      </ButtonGroup>
    </FieldSet>
  );
};

export default DatabaseConnectionSection;
export { DatabaseConnectionSection };
